export const mobileStickyPrimaryClassName =
  "inline-flex min-h-[52px] w-full items-center justify-center gap-2 rounded-lg bg-accent px-5 py-3 text-base font-bold text-white shadow-sm transition-colors hover:bg-accent-dark disabled:cursor-not-allowed disabled:opacity-50";

export function MobileStickyAction({ children }: { children: React.ReactNode }) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background/95 px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] shadow-[0_-10px_30px_rgba(15,23,42,0.12)] backdrop-blur sm:hidden">
      <div className="mx-auto max-w-md">{children}</div>
    </div>
  );
}
